import React__default from 'react';
import { motion } from 'framer-motion';
import { Heading } from '@grandvisionhq/elements';
import { isProductRecommendation } from './utils/guards.js';
import { isValidRecommendation } from './utils/is-valid-recommendation.js';
import { ListItemWrapper } from './components/ListItemWrapper.js';
import { ProductRecommendationContainer } from './components/ProductRecommendationContainer.js';
import { BannerRecommendationContainer } from './components/BannerRecommendationContainer.js';

const RecommendationListMiniCart = ({ labels , recommendations , locale , formatProductUrl , className ,  })=>{
    const validRecommendations = recommendations.filter(isValidRecommendation);
    if (!validRecommendations.length) return null;
    return /*#__PURE__*/ React__default.createElement(motion.div, {
        style: {
            overflow: 'hidden'
        },
        variants: {
            start: {
                height: 0
            },
            end: {
                height: 'auto'
            }
        },
        transition: {
            type: 'tween'
        },
        initial: "start",
        animate: "end",
        className: `recommendation-list ${className}`
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        component: "h2",
        variant: "smallest",
        className: "recommendation-list__title"
    }, labels.title), /*#__PURE__*/ React__default.createElement(motion.ul, {
        variants: {
            start: {
                opacity: 1
            },
            end: {
                opacity: 1
            }
        },
        transition: {
            delayChildren: 0.25,
            staggerChildren: 0.1
        },
        className: "recommendation-list__list"
    }, validRecommendations.map((recommendation, index)=>isProductRecommendation(recommendation) ? /*#__PURE__*/ React__default.createElement(ListItemWrapper, {
            key: recommendation.sku
        }, /*#__PURE__*/ React__default.createElement(ProductRecommendationContainer, {
            recommendation: recommendation,
            locale: locale,
            formatProductUrl: formatProductUrl,
            position: index + 1
        })) : /*#__PURE__*/ React__default.createElement(ListItemWrapper, {
            key: `${recommendation.position}-${recommendation.title}`
        }, /*#__PURE__*/ React__default.createElement(BannerRecommendationContainer, {
            recommendation: recommendation
        }))
    )));
};

export { RecommendationListMiniCart };
//# sourceMappingURL=RecommendationListMiniCart.js.map
